/* Galerio v0.4.1 - Bez zoom-a, tačan indeks po href + dedupe
 * - Uklonjen zoom/pan/wheel
 * - Swipe navigacija
 * - Deduplikacija slika po HREF-u (kada postoji više .galerio instanci sa istim group-om)
 * - Klik otvara baš tu sliku (indeks se traži globalno po href)
 */
(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));

  let modal,
    lastFocused,
    hashActive = false;

  const anyHashEnabled = () => !!document.querySelector('.galerio[data-gal-hash="true"]');
  const isHashEnabledFor = (group) => {
    const el = document.querySelector(`.galerio[data-gal-group="${group}"]`);
    return el && el.getAttribute("data-gal-hash") === "true";
  };

  function createModal() {
    const wrap = document.createElement("div");
    wrap.className = "gal-modal";
    wrap.setAttribute("aria-hidden", "true");

    wrap.innerHTML = `
      <div class="gal-backdrop" data-gal="backdrop"></div>
      <div class="gal-dialog" role="dialog" aria-modal="true" aria-label="Image viewer" tabindex="-1">
        <button class="gal-close" type="button" aria-label="Close">✕</button>
        <button class="gal-prev"  type="button" aria-label="Previous">‹</button>
        <div class="gal-stage">
          <img class="gal-img" alt="">
        </div>
        <button class="gal-next"  type="button" aria-label="Next">›</button>
        <div class="gal-caption" aria-live="polite"></div>
        <div class="gal-thumbs" data-gal="thumbs"></div>
      </div>
    `;
    document.body.appendChild(wrap);

    const m = {
      root: wrap,
      dlg: qs(".gal-dialog", wrap),
      img: qs(".gal-img", wrap),
      stage: qs(".gal-stage", wrap),
      cap: qs(".gal-caption", wrap),
      prev: qs(".gal-prev", wrap),
      next: qs(".gal-next", wrap),
      close: qs(".gal-close", wrap),
      thumbs: qs('[data-gal="thumbs"]', wrap),
      backdrop: qs('[data-gal="backdrop"]', wrap),
    };

    // focus trap
    m.dlg.addEventListener("keydown", (e) => {
      if (e.key !== "Tab") return;
      const focusables = qsa('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])', m.dlg).filter(
        (el) => !el.hasAttribute("disabled") && el.offsetParent !== null
      );
      if (!focusables.length) return;
      const first = focusables[0],
        last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    });

    // controls
    m.prev.addEventListener("click", () => nav(-1));
    m.next.addEventListener("click", () => nav(+1));
    m.close.addEventListener("click", close);

    // klik po stage-u izvan slike -> zatvori
    m.stage.addEventListener("click", (e) => {
      if (e.target.closest(".gal-img")) return;
      close();
    });

    // klik bilo gde u dialogu što NIJE slika/strelice/thumbs/close -> zatvori
    m.dlg.addEventListener("click", (e) => {
      if (
        e.target.closest(".gal-img") ||
        e.target.closest(".gal-prev") ||
        e.target.closest(".gal-next") ||
        e.target.closest(".gal-thumbs") ||
        e.target.closest(".gal-close")
      )
        return;
      close();
    });

    m.backdrop.addEventListener("click", close);

    // keys global
    document.addEventListener("keydown", (e) => {
      if (!modal || modal.root.getAttribute("aria-hidden") === "true") return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") nav(-1);
      else if (e.key === "ArrowRight") nav(+1);
    });

    // touch swipe za navigaciju
    setupSwipe(m.stage);

    return m;
  }

  // Touch swipe navigacija
  function setupSwipe(stage) {
    let sx = 0,
      sy = 0,
      ex = 0,
      ey = 0,
      swiping = false;

    stage.addEventListener(
      "touchstart",
      (e) => {
        sx = e.changedTouches[0].screenX;
        sy = e.changedTouches[0].screenY;
        swiping = true;
      },
      { passive: true }
    );

    stage.addEventListener(
      "touchmove",
      (e) => {
        if (!swiping) return;
        ex = e.changedTouches[0].screenX;
        ey = e.changedTouches[0].screenY;
      },
      { passive: true }
    );

    stage.addEventListener(
      "touchend",
      () => {
        if (!swiping) return;
        swiping = false;
        const dx = ex - sx,
          dy = ey - sy;
        const MIN = 50;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > MIN) {
          if (dx > 0) nav(-1);
          else nav(+1);
        }
      },
      { passive: true }
    );
  }

  function lockScroll(lock) {
    const html = document.documentElement;
    if (lock) {
      if (!html.dataset.galScrollY) {
        html.dataset.galScrollY = String(window.scrollY);
        html.style.top = `-${html.dataset.galScrollY}px`;
        html.classList.add("gal-lock");
        html.style.position = "fixed";
        html.style.left = "0";
        html.style.right = "0";
      }
    } else {
      const y = parseInt(html.dataset.galScrollY || "0", 10);
      html.classList.remove("gal-lock");
      html.style.position = "";
      html.style.left = "";
      html.style.right = "";
      html.style.top = "";
      window.scrollTo(0, y);
      delete html.dataset.galScrollY;
    }
  }

  function preload(srcOrSet) {
    if (!srcOrSet) return;
    const img = new Image();
    if (srcOrSet.includes("w,") || srcOrSet.includes(" 1x") || srcOrSet.includes(" 2x")) {
      img.srcset = srcOrSet;
      img.sizes = "100vw";
      const first = srcOrSet.split(",")[0].trim().split(" ")[0];
      img.src = first;
    } else {
      img.src = srcOrSet;
    }
  }

  // ===== Ključ: globalna lista slika po group-u, dedupe po href =====
  function parseItems(group) {
    const anchors = qsa(`.gal-item[data-gal-group="${group}"]`);
    const out = [];
    const seen = new Set();

    anchors.forEach((a) => {
      const img = a.querySelector("img");
      const href = a.getAttribute("data-gal-src") || a.getAttribute("href");
      if (!href) return;

      // Dedupe po HREF-u (isti URL ne dodajemo drugi put)
      if (seen.has(href)) return;
      seen.add(href);

      out.push({
        a,
        href,
        srcset: a.getAttribute("data-gal-srcset") || "",
        caption: a.getAttribute("data-gal-caption") || (img ? img.getAttribute("alt") || "" : ""),
        thumb: img ? img.currentSrc || img.src : href,
        alt: img ? img.getAttribute("alt") || "" : "",
      });
    });

    return out;
  }

  function mountGalerio(root) {
    const items = qsa(".gal-item", root);
    if (!items.length) return;

    const group = root.getAttribute("data-gal-group") || `gal-${Math.random().toString(36).slice(2)}`;
    const preloadN = parseInt(root.getAttribute("data-gal-preload") || "2", 10);
    root.setAttribute("data-gal-group", group);

    // Obeležimo group na svakom <a>, ali NE oslanjamo se na lokalni data-gal-index
    items.forEach((a) => a.setAttribute("data-gal-group", group));

    // Klik handler: na osnovu HREF-a nađi globalni indeks i otvori baš tu sliku
    root.addEventListener("click", (e) => {
      const a = e.target.closest && e.target.closest(".gal-item");
      if (!a || !root.contains(a)) return;
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();

      const href = a.getAttribute("data-gal-src") || a.getAttribute("href");
      if (!href) return;

      const all = parseItems(group);
      const idx = Math.max(
        0,
        all.findIndex((it) => it.href === href)
      );
      openAt(group, idx);
    });

    root._gal = { group, preloadN };
  }

  function ensureModal() {
    if (!modal) modal = createModal();
  }

  function openAt(group, index = 0) {
    ensureModal();
    lastFocused = document.activeElement;

    const items = parseItems(group);
    if (!items.length) return;

    const state = { group, i: index, items, preloadN: findPreloadFor(group) };
    modal.root._galState = state;

    buildThumbs(group, items, index);

    modal.root.setAttribute("open", "");
    modal.root.removeAttribute("aria-hidden");
    modal.dlg.focus();
    lockScroll(true);

    show(state, index, /*pushHash=*/ true);
  }

  function findPreloadFor(group) {
    const el = qs(`.galerio[data-gal-group="${group}"]`);
    return parseInt(el?.getAttribute("data-gal-preload") || "2", 10);
  }

  function buildThumbs(group, items, activeIdx) {
    if (modal.root._galGroup !== group) {
      modal.thumbs.innerHTML = "";
      modal.root._galGroup = group;
      modal.thumbs._builtCount = 0;
      modal.thumbs._itemsCache = items;
      modal.thumbs.addEventListener("scroll", maybeBuildMore, { passive: true });
    }
    maybeBuildMore();
    updateThumbCurrent(activeIdx);
  }

  function maybeBuildMore() {
    const items = modal.thumbs._itemsCache || [];
    const built = modal.thumbs._builtCount || 0;
    if (built >= items.length) return;
    const CHUNK = 40;
    const need = Math.min(CHUNK, items.length - built);
    const frag = document.createDocumentFragment();
    for (let i = built; i < built + need; i++) {
      const it = items[i];
      const b = document.createElement("button");
      b.type = "button";
      b.className = "gal-thumb-btn";
      b.setAttribute("aria-label", `Go to image ${i + 1}`);
      const im = document.createElement("img");
      im.alt = it.alt || "";
      im.src = it.thumb || it.href;
      b.appendChild(im);
      b.addEventListener("click", () => {
        const st = modal.root._galState;
        if (!st) return;
        show(st, i, /*pushHash=*/ true);
      });
      frag.appendChild(b);
    }
    modal.thumbs.appendChild(frag);
    modal.thumbs._builtCount = built + need;
  }

  function updateThumbCurrent(idx) {
    qsa(".gal-thumb-btn", modal.thumbs).forEach((el, i) => {
      if (i === idx) el.setAttribute("aria-current", "true");
      else el.removeAttribute("aria-current");
    });
    const activeThumb = qsa(".gal-thumb-btn", modal.thumbs)[idx];
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }

  function show(state, idx, pushHash = false) {
    const { items } = state;
    if (idx < 0) idx = items.length - 1;
    if (idx >= items.length) idx = 0;
    state.i = idx;

    const it = items[idx];

    // Loading state
    modal.img.classList.add("loading");

    if (it.srcset) {
      modal.img.srcset = it.srcset;
      modal.img.sizes = "100vw";
      modal.img.src = it.srcset.split(",")[0].trim().split(" ")[0];
    } else {
      modal.img.removeAttribute("srcset");
      modal.img.removeAttribute("sizes");
      modal.img.src = it.href;
    }
    modal.img.alt = it.alt || it.caption || "";
    modal.cap.textContent = it.caption || it.alt || "";

    modal.img.onload = () => modal.img.classList.remove("loading");

    updateThumbCurrent(idx);

    for (let step = 1; step <= state.preloadN; step++) {
      const next = items[(idx + step) % items.length];
      const prev = items[(idx - step + items.length) % items.length];
      preload(next.srcset || next.href);
      preload(prev.srcset || prev.href);
    }

    if (pushHash && isHashEnabledFor(state.group)) {
      hashActive = true;
      const newHash = `#galerio=${encodeURIComponent(state.group)}:${idx}`;
      if (location.hash !== newHash) {
        history.replaceState(null, "", newHash);
      }
    }
  }

  function close() {
    if (!modal) return;
    modal.root.removeAttribute("open");
    modal.root.setAttribute("aria-hidden", "true");
    lockScroll(false);
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    if (hashActive && anyHashEnabled() && location.hash.startsWith("#galerio=")) {
      history.replaceState(null, "", location.pathname + location.search);
      hashActive = false;
    }
  }

  function nav(delta) {
    const st = modal.root._galState;
    if (!st) return;
    show(st, st.i + delta, /*pushHash=*/ true);
  }

  // ===== Deep-linking =====
  function parseHash() {
    if (!location.hash.startsWith("#galerio=")) return null;
    try {
      const payload = location.hash.slice(10);
      const [grp, idxStr] = payload.split(":");
      const group = decodeURIComponent(grp);
      const idx = parseInt(idxStr || "0", 10) || 0;
      return { group, idx };
    } catch {
      return null;
    }
  }

  window.addEventListener("hashchange", () => {
    if (!anyHashEnabled()) return;
    const parsed = parseHash();
    if (parsed) {
      const st = modal?.root?._galState;
      if (st && st.group === parsed.group) {
        show(st, parsed.idx, /*pushHash=*/ false);
      } else {
        openAt(parsed.group, parsed.idx);
      }
    } else if (modal && modal.root.getAttribute("aria-hidden") !== "true") {
      close();
    }
  });

  // ===== Auto-init & observer =====
  function init() {
    qsa(".galerio").forEach(mountGalerio);

    if (anyHashEnabled()) {
      const parsed = parseHash();
      if (parsed) openAt(parsed.group, parsed.idx);
    }

    const mo = new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes &&
          m.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            if (node.matches && node.matches(".galerio")) mountGalerio(node);
            qsa(".galerio", node).forEach(mountGalerio);
          });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // API
  window.Galerio = {
    mount: mountGalerio,
    openAt,
    close,
    next: () => nav(+1),
    prev: () => nav(-1),
    refresh(group) {
      if (!modal) return;
      const st = modal.root._galState;
      if (st && st.group === group) {
        st.items = parseItems(group);
        buildThumbs(group, st.items, st.i);
      }
    },
  };
})();
